/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Heading1, Paragraph } from '@motili/ui';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import { styled } from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../common/redux/hooks';
import { resetState } from '../../../common/redux/ducks/contractorRegistrationForm';
import StyledButton from '../../../components/styled/StyledButton';

interface WelcomeProps {
    handleNextClick: () => void;
}

export default function Welcome({
    handleNextClick,
}: WelcomeProps): ReactElement {
    const dispatch = useAppDispatch();
    const starterInfo = useAppSelector(
        ({ clientRegistration }) => clientRegistration.starterInfo
    );

    const startOver = () => {
        dispatch(resetState());
    };

    return (
        <CenteredContainer>
            <Heading starterInfo={starterInfo} startOver={startOver} />
            <Paragraph>Welcome to client registration.</Paragraph>
            <br />
            <StyledButton variant='primary' onClick={handleNextClick}>
                Next
            </StyledButton>
        </CenteredContainer>
    );
}

const Heading = (props: any) => {
    const { starterInfo, startOver } = props;
    if (starterInfo?.firstName) {
        const welcomeMessage = `Welcome back, ${starterInfo.firstName}!`;
        return (
            <>
                <Heading1>{welcomeMessage}</Heading1>
                <StyledParagraph>
                    To continue where you left off, click the Next button below
                    or click Start Over to start fresh.
                    <StyledButton onClick={startOver}>Start Over</StyledButton>
                </StyledParagraph>
            </>
        );
    }
    return <Heading1>Welcome</Heading1>;
};

const StyledParagraph = styled(Paragraph)`
    ${props => `background-color: ${props.theme.color('gray500')}`};
    border-radius: 5px;
    padding: 15px;
`;
